// extracted by mini-css-extract-plugin
export default {"app":"UploadAni_app__e+PBI","ani":"UploadAni_ani__LsuOV","player":"UploadAni_player__3vdxC"};